module.exports = __webpack_public_path__ + "img/project-overview.e4e1f378.svg";